import { useNavigate } from "react-router-dom";
import { ProductGrid } from "../product";
import { SEO } from "../SEO";

export function BlackHistorySection({ products, isPage }) {
  const navigate = useNavigate();
  const blackHistoryProducts = products.filter(p => p.collection === "Black History");
  
  const taglines = [
    "Our History. Our Legacy. Our Power.",
    "Standing on the Shoulders of Giants.",
    "Honoring the Past. Building the Future.",
    "Excellence Runs in Our Blood."
  ];
  
  return (
    <section className={`py-20 px-4 ${isPage ? 'pt-32' : ''} bg-gradient-to-b from-black via-amber-950/10 to-black`} data-testid="blackhistory-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          {isPage && <SEO title="Black History Collection" description="Fresh Po'Boy Black History Collection. Celebrate the culture with premium streetwear honoring Black excellence." path="/blackhistory" />}
          <span className="text-amber-400 text-sm tracking-widest uppercase">Celebrate the Culture</span>
          <h2 className="text-white text-5xl sm:text-6xl font-bebas mt-2">Black History <span className="text-amber-400">Collection</span></h2>
          <p className="text-white/60 mt-4 max-w-xl mx-auto">Honoring our roots. Celebrating our excellence. Wear your heritage with pride.</p>
        </div>
        
        {/* Black History Taglines */}
        {isPage && (
          <div className="mb-16">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
              {taglines.map((tagline, index) => (
                <div 
                  key={tagline} 
                  className={`p-5 rounded-xl ${
                    index % 2 === 0 
                      ? 'bg-amber-500/10 border border-amber-500/30' 
                      : 'bg-red-600/10 border border-red-600/30'
                  } text-center`}
                >
                  <p className={`text-sm sm:text-base font-bold ${
                    index % 2 === 0 ? 'text-amber-400' : 'text-red-500'
                  }`}>
                    "{tagline}"
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Heritage Message for Page View */}
        {isPage && (
          <div className="mb-16 max-w-4xl mx-auto">
            <div className="bg-gradient-to-r from-amber-500/10 via-red-600/10 to-amber-500/10 rounded-2xl p-8 border border-amber-500/20 text-center">
              <p className="text-white/80 text-lg leading-relaxed">
                This collection celebrates the <span className="text-amber-400 font-semibold">trailblazers, dreamers, and legends</span> who 
                paved the way. Every piece tells a story of <span className="text-red-500 font-semibold">resilience, excellence, and 
                unwavering strength</span>. When you wear Black History, you wear a legacy.
              </p>
            </div>
          </div>
        )}
        
        <ProductGrid products={blackHistoryProducts} />
        
        {!isPage && blackHistoryProducts.length > 0 && (
          <div className="text-center mt-12">
            <button 
              onClick={() => navigate('/blackhistory')} 
              className="px-8 py-4 bg-amber-500 text-black font-semibold hover:bg-amber-400 transition-colors"
              data-testid="view-blackhistory-collection-btn"
            >
              View Full Collection
            </button>
          </div>
        )}

        {/* Empty State */}
        {isPage && blackHistoryProducts.length === 0 && (
          <div className="text-center py-16">
            <div className="bg-zinc-900/50 rounded-2xl p-12 max-w-2xl mx-auto border border-amber-500/20">
              <p className="text-amber-400 text-6xl mb-4">✊🏿</p>
              <h3 className="text-white text-2xl font-bebas mb-4">Collection Coming Soon</h3>
              <p className="text-white/60 mb-6">
                We're working on powerful designs to honor Black history and excellence. 
                Check back soon for exclusive drops.
              </p>
              <button 
                onClick={() => navigate('/shop')} 
                className="px-6 py-3 bg-amber-500 text-black font-semibold hover:bg-amber-400 transition-colors"
              >
                Shop Other Collections
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
